import SettingsTabBase from "./SettingsTabBase.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { assignViewsState } from "../../../other/utils/otherUtils.jsx";
import {cellMenuItemRemoveRow} from "../../../other/utils/gridCellMenuUtils.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";
import { cellAvatarTooltipConfig } from "../../../other/utils/utils.jsx";

export default class SwivuSettingsTagValueTabBase extends SettingsTabBase {
  static get $name() {
    return "SwivuSettingsTagValueTabBase";
  }

  static get type() {
    return "swivusettingstagvaluetabbase";
  }

  static getGridWidget({ headerText, defaultValue, canSwivuNotifyUser = false }) {
    return {
      type: WIDGET_KEYS.swivuGrid,
      preserveScrollOnDatasetChange: true,
      canSwivuNotifyUser,
      height: "100%",
      width: "100%",
      scrollable: true,
      cls: "tag-grid-container",
      features: {
        sort: false,
        group: false,
        rowReorder: { showGrip: true },
        stripe: { disabled: true },
        cellMenu: {
          items: {
            cut: false,
            copy: false,
            paste: false,
            removeRow: cellMenuItemRemoveRow()
          }
        },
        cellTooltip: cellAvatarTooltipConfig
      },
      listeners: {
        cellClick: "up.onGridCellClick"
      },
      columns: [
        {
          id: "tagValue",
          text: headerText,
          flex: 1,
          field: "tagValue",
          editable: true,
          editor: {
            required: true,
            placeholder: defaultValue
          },
          finalizeCellEdit: "up.onFinalizeTitleField"
        },
        {
          id: "notify",
          text: "Notify",
          type: WIDGET_KEYS.notifyColumn,
        }
      ],
      bbar: [
        {
          type: "button",
          icon: "fa fa-plus",
          color: "b-green"
        },
        {
          type: "button",
          icon: "fa fa-trash",
          color: "b-red"
        }
      ]
    };
  }

  assignListenersToToolbarButtons(gridWidget, tagType) {
    gridWidget.bbar.firstItem.removeAllListeners();
    gridWidget.bbar.lastItem.removeAllListeners();
    gridWidget.bbar.firstItem.on("click", () =>
      this.onAdd(tagType, gridWidget)
    );
    gridWidget.bbar.lastItem.on("click", () =>
      this.onRemove(tagType, gridWidget)
    );
    gridWidget.features.cellMenu.items.removeRow.onItem = () => this.onRemove(tagType, gridWidget);
  }

  attachState(gridWidget, widgetRef) {
    gridWidget.stateId = `b-settings-tab-${widgetRef}-v2`;
    assignViewsState([gridWidget], this.stateProvider);
  }

  loadRecord(record, context) {
    super.loadRecord(record, context);

    const store = context.project.getCrudStore(this.getStoreName());
    const tagWithWidgetRef = this.getTagKeysWithWidgetRef();

    Object.keys(tagWithWidgetRef).forEach((tagType) => {
      const widgetRef = tagWithWidgetRef[tagType];
      // We were facing an issue when reorder record it does update records positions in chained store but leaving the main store
      // from which this chained store created, kept intact, the solution to update position in main store is to relay the move event on
      // main store
      const specificTypeStoreData = store.query((record) => record.tagSet === tagType, true);
      const gridWidget = this.widgetMap[widgetRef];
      gridWidget.columns.getById("notify").onLoad(context.project);
      // Notify column for now is only required in task status grid
      // However, it will be enabled for all the tag grids (categories, tags, status) in future
      if (!gridWidget.canSwivuNotifyUser) {
        gridWidget.columns.getById("notify").hidden = true;
        gridWidget.features.headerMenu.processItems = ({ items }) => {
          items.columnPicker.menu.items.find((item) => item.column.field === "notifyees").disabled = true;
        }
      }
      this.assignListenersToToolbarButtons(
        gridWidget,
        tagType
      );
      gridWidget.store.data = specificTypeStoreData;
      gridWidget.store.swivuCrudManager = context.project;
      gridWidget.store.swivuMasterStore = store;
      this.attachState(gridWidget, widgetRef);
    });
  }

  onAdd(tagType, gridWidget) {
    const lastItemOrder = gridWidget.store.last?.order;
    const currentItemOrder = isNaN(lastItemOrder) ? 0 : lastItemOrder + 1;
    const newRecord = this.project.getCrudStore(this.getStoreName()).createRecord({
      tagSet: tagType,
      tagValue: "",
      order: currentItemOrder
    });
    gridWidget.store.add(newRecord);
    gridWidget.startEditing({ record: newRecord, field: "tagValue" })
  }

  onRemove(tagType, gridWidget) {
    const removeSelected = gridWidget.selectedRecords;
    const tagStore = this.project.getCrudStore(this.getStoreName())
    if (removeSelected.length) {
      const selectedIds = removeSelected.map((r) => r.id);
      gridWidget.store.remove(selectedIds);
      tagStore.remove(selectedIds);
    }
  }

  static getDefaultLayoutSettings() {
    return {
      cls: "swivu-board-tags-tab-container gap-[1em]"
    };
  }

  onFinalizeTitleField({ grid, value, record }) {
    const cellValue = value.trim();
    if (!cellValue) return false;
    const existingTagRecord = grid.store.find((tagRecord) => tagRecord.tagValue === cellValue);
    if (existingTagRecord) return "Record already exists";
    if (record.isPhantom) this.project.getCrudStore(this.getStoreName()).add(record)
    return true;
  }

  getEditableField() {
    return false;
  }

  onGridCellClick({ column, record, event }) {
    if (column.type === WIDGET_KEYS.notifyColumn) {
      this.context.editorHandler.openEditor(
        EDITOR_KEYS.entityTagEditor,
        null,
        {
          entityRecord: record,
          event,
          column
        },
        { by: "recordType", useExisting: true }
      );
    }
  }
}
